import { FC, ReactElement } from 'react'
import { Container } from './styles'

type SkeletonProps = {
  visible?: boolean
}

const Skeleton: FC<SkeletonProps> = ({ visible = true, children }): ReactElement => {
  if (!visible) return <>{children}</>

  return (
    <Container className='skeleton'>
      {children}
    </Container>
  )
}

export default Skeleton
